<template>
  <div class="container">
    <!-- <van-nav-bar v-if="active!=='/user'" fixed @click-right="$router.push('/search')" /> -->
    <!-- <van-nav-bar left-arrow @click-left="$router.back()"></van-nav-bar> -->

    <div class="my-wrapper">
      <!-- 二级路由 视图位置 -->
      <keep-alive>
        <router-view></router-view>
      </keep-alive>
    </div>
    <!-- route 开启路由模式 -->
    <!-- <van-tabbar :value="active" route> 
      <van-tabbar-item size="24" name="/home" to="/home">
        <span>首页</span>
        <template #icon="props">
          <i :class="[props.active ? 'homeItem1' : 'homeItem']"></i> 
        </template>
      </van-tabbar-item>
      <van-tabbar-item name="/control" to="/control">
        <span>用电场景</span>
        <template #icon="props">
          <i :class="[props.active ? 'mentItem1' : 'mentItem']"></i>
        </template>
      </van-tabbar-item>
      <van-tabbar-item name="/controlAir" to="/controlAir">
        <span>空调控制</span>
        <template #icon="props">
          <i :class="[props.active ? 'yuItem1' : 'yuItem']"></i>
        </template>
      </van-tabbar-item>
      <van-tabbar-item name="/my" to="/my" icon="contact">
        <span>我的</span>
        <template #icon="props">
          <i :class="[props.active ? 'myItem' : 'myItem1']"></i> 
        </template>
      </van-tabbar-item>
    </van-tabbar> -->
  </div>
</template>

<script>
export default {
  data() {
    return {
      // active: 0
    };
  },
  // 当去切换二级路由组件的时候 ，当前组件Layout是没有重新初始化的， data中的数据不会变化
  // 计算属性：当依赖的数据变化的时候 自己也会变化
  // 当然你可以不是有  模版内需要使用 $route.path
  computed: {
    active() {
      return this.$route.path;
    },
  },
};
</script>

<style lang="less" scoped>
.container {
  width: 100%;
  height: 100%;
  position: relative;
  .my-wrapper {
    width: 100%;
    height: 100%;
    overflow-x: hidden;
    // padding-top: 46px;
    // padding-bottom: 50px;
    box-sizing: border-box;
    background-color: rgba(244, 246, 250, 1);
    &.noTop {
      padding-top: 0;
    }
  }
}
.homeItem {
  display: block;
  width: 20px;
  height: 20px;
  background: url(../assets/switchBar/home.png) no-repeat;
  background-size: 20px;
}
.homeItem1 {
  display: block;
  width: 20px;
  height: 20px;
  background: url(../assets/switchBar/hom2.png) no-repeat;
  background-size: 20px;
}
.myItem {
  display: block;
  width: 20px;
  height: 20px;
  background: url(../assets/switchBar/my.png);
  background-size: 20px;
}
.myItem1 {
  display: block;
  width: 20px;
  height: 20px;
  background: url(../assets/switchBar/my2.png);
  background-size: 20px;
}
.mentItem {
  display: block;
  width: 20px;
  height: 20px;
  background: url(../assets/switchBar/dian.png);

  background-size: 20px;
}
.mentItem1 {
  display: block;
  width: 20px;
  height: 20px;
  background: url(../assets/switchBar/dian2.png);

  background-size: 20px;
}
.yuItem {
  display: block;
  width: 20px;
  height: 20px;
  background: url(../assets/switchBar/air.png);
  background-size: 20px;
}
.yuItem1 {
  display: block;
  width: 20px;
  height: 20px;
  background: url(../assets/switchBar/air2.png);
  background-size: 20px;
}
</style>
